import React from "react";
import * as styles from "./ContactBlockV2.module.scss";
import { GatsbyImage } from "gatsby-plugin-image";
// import ComparisonTableImgDesktop from "../../images/campaign/solution-desktop-version.svg";
// import ComparisonTableImgMobile from "../../images/campaign/solution-mobile-version.svg";
import { Link } from "gatsby";
import ComparisonTable from "../ComparisonTable/ComparisonTable";

const ContactBlockV2 = ({
  heading,
  description,
  backgroundImage,
  solutionPage,
  comparisonTable,
  btnText,
  btnSlug,
}) => {
  return (
    <>
      {solutionPage ? (
        <div className={styles.comparison_table}>
          <div
            className={styles.contact_block_v2_solutionPage}
            style={{ backgroundImage: `url(${backgroundImage})` }}
          >
            <div className={styles.contact_block_v2_solutionPage_content_v1}>
              <p className="gap-1x text-p2">{heading}</p>
              <h2 className="text-h1 text-fw-medium gap-1x text-center">
                {description || ""}
              </h2>
            </div>
          </div>
          <div className={styles.comparison_desktop}>
            <ComparisonTable data={comparisonTable} />
            <div className={styles.btns}>
              <Link to={btnSlug} className={styles.solutionBtn}>
                {btnText}
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div
            className={styles.contact_block_v2}
            style={{ backgroundImage: `url(${backgroundImage})` }}
          >
            {/* <GatsbyImage
        image={backgroundImage}
        alt="Background"
        className={styles.contact_block_v2_image}
      /> */}
            <div className={styles.contact_block_v2_content}>
              <h2 className="text-h1 text-fw-medium gap-1x">{heading}</h2>
              <p className="gap-3x text-p2">{description}</p>
              <div className="btns">
                <Link to="/contact/" className="secondary-btn">
                  Book free consultation
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactBlockV2;
